import { createFileRoute } from "@tanstack/react-router";

import { IntegrationsPage } from "@/components/marketing/integrations-page";
import { pageHead } from "@/lib/seo";

export const Route = createFileRoute("/(public)/integrations")({
  head: () => pageHead("integrations"),
  component: IntegrationsPage,
});
